/*
 * @Author: your name
 * @Date: 2021-03-10 15:35:09
 * @LastEditTime: 2021-07-10 14:28:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\router\index.js
 */
/*
 * @Author: your name
 * @Date: 2021-03-10 15:35:09
 * @LastEditTime: 2021-03-11 09:23:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import ProductRouter from './modules/product.js'
import SettledRouter from './modules/settled.js';
import OrderRouter from './modules/order.js';
import PersonRouter from './modules/settings';
import AccountRouter from './modules/account';
import Settlement from './modules/settlement'
import pageDesign from './modules/pageDesign'
import money from './modules/money'
import Insurance from './modules/insurance'
import Ticket from './modules/ticket'


import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/',
      component: resolve => require(['../common/Home.vue'], resolve),
      meta: { title: '自述文件' },
      children: [
        {
          path: '/about',
          component: resolve => require(['../views/about/index'], resolve),
          meta: { title: '首页' }
        },
        ...SettledRouter,
        ...ProductRouter,
        ...OrderRouter,
        ...PersonRouter,
        ...AccountRouter,
        ...Settlement,
        ...pageDesign,
        ...money,
        ...Insurance,
        ...Ticket
      ]
    },
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home,
    //   meta: {
    //     title: '首页'
    //   }
    // }
  ]
})
// router.beforeEach((to, from, next) => {
//   NProgress.start()
//   next()
// })

router.beforeEach((to, from, next) => {
  NProgress.start()
  // console.log(to,'判断刷新是否进入',router.app.$options.store)
  var store = router.app.$options.store;
  if(router.app.$options.store.state.user && router.app.$options.store.state.user.userData && router.app.$options.store.state.user.userData[0] && router.app.$options.store.state.user.userData[0].orgCode){
    console.log(to,'判断刷新是否进入',router.app.$options.store.state.user.userData[0].orgCode)
    next()
  }else{
    setTimeout(()=>{
      if(router.app.$options.store.state.user && router.app.$options.store.state.user.userData && router.app.$options.store.state.user.userData[0] && router.app.$options.store.state.user.userData[0].orgCode){
        console.log(to,'判断刷新是否进入',router.app.$options.store.state.user.userData[0].orgCode)
        next()
      }else{
        setTimeout(()=>{
          if(router.app.$options.store.state.user && router.app.$options.store.state.user.userData && router.app.$options.store.state.user.userData[0] && router.app.$options.store.state.user.userData[0].orgCode){
            console.log(to,'判断刷新是否进入',router.app.$options.store.state.user.userData[0].orgCode)
            next()
          }else{
            setTimeout(()=>{             
                next()                     
            },2500)
          }
         
        },1500)
      }
    },1500)
  }


  // next()
 })

router.afterEach((to, from) => {
  console.log('页面跳转后执行')
  document.getElementById("main-content").scrollTop = 0
  NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/SRM/router/index.js